<div
  class="
    d-flex
    flex-column flex-xl-row flex-row-fluid
  "
  id="kt_create_account_stepper"
>
  <div
    class="
      d-flex
      justify-content-center
      justify-content-xl-start
      flex-row-auto
      stepper stepper-pills stepper-column
      me-xl-10 me-xxl-18
      w-100 w-xl-300px
    "
  >
    <div class="stepper-nav">
      <div
        class="stepper-item"
        [ngClass]="{
            current: (currentStep$ | async)! === 1,
            completed: (currentStep$ | async)! > 1
          }"
      >
        <div class="stepper-line"></div>

        <div class="stepper-icon">
          <i class="stepper-check fas fa-check"></i>
          <span class="stepper-number">1</span>
        </div>

        <div class="stepper-label">
          <h3 class="stepper-title">{{ "WIZARD.ACCOUNT_TYPE" | translate }}</h3>
          <div class="stepper-desc fw-bold">{{ "WIZARD.ACCOUNT_TYPE_DESC" | translate }}</div>
        </div>
      </div>

      <div
        class="stepper-item"
        [ngClass]="{
            current: (currentStep$ | async)! === 2,
            completed: (currentStep$ | async)! > 2
          }"
      >
        <div class="stepper-line"></div>

        <div class="stepper-icon">
          <i class="stepper-check fas fa-check"></i>
          <span class="stepper-number">2</span>
        </div>

        <div class="stepper-label">
          <h3
            class="stepper-title">
            {{ (account$ |async)!.accountType | appAccountTranslate:'WIZARD.SHOP.SHOP_DATA':'WIZARD.ADVERTISER.ADVERTISER_DATA' }}
          </h3>
          <div
            class="stepper-desc fw-bold">
            {{ (account$ |async)!.accountType | appAccountTranslate:'WIZARD.SHOP.SHOP_DATA_DESC':'WIZARD.ADVERTISER.ADVERTISER_DATA_DESC'}}
          </div>
        </div>
      </div>

      <div
        class="stepper-item"
        [ngClass]="{
            current: (currentStep$ | async)! === 3,
            completed: (currentStep$ | async)! > 3
          }"
      >
        <div class="stepper-line"></div>

        <div class="stepper-icon">
          <i class="stepper-check fas fa-check"></i>
          <span class="stepper-number">3</span>
        </div>

        <div class="stepper-label">
          <h3 class="stepper-title">{{ "WIZARD.SHOP.COMPANY_INFORMATION" | translate }}</h3>
          <div class="stepper-desc fw-bold">{{ "WIZARD.SHOP.COMPANY_INFORMATION_DESC" | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row-fluid flex-center bg-white rounded">
    <form
      class="w-100"
      noValidate
      id="kt_create_account_form"
    >
      <div class="current">
        <ng-container *ngIf="(currentStep$ | async)! === 1">
          <app-step1
            class="w-100"
            [defaultValues]="(account$ | async)!"
            (updateParentModel)="updateAccount($event)"
            (nextStep)="nextStep()"
          ></app-step1>
        </ng-container>

        <ng-container *ngIf="(currentStep$ | async)! === 2">
          <app-step2
            class="w-100"
            [backendValidationErrorsList]="(backendValidationErrorsListStep2$ | async) || []"
            [defaultValues]="(account$ | async)!"
            (updateParentModel)="updateAccount($event)"
            (nextStep)="nextStep()"
            (prevStep)="prevStep()"
          ></app-step2>
        </ng-container>

        <ng-container *ngIf="(currentStep$ | async)! === 3">
          <app-step3
            class="w-100"
            [backendValidationErrorsList]="(backendValidationErrorsListStep3$|async) || []"
            [defaultValues]="(account$ | async)!"
            [isFormDisabled]="(isCreatingAccount$ | async) === true"
            (updateParentModel)="updateAccount($event)"
            (nextStep)="nextStep()"
            (prevStep)="prevStep()"
          ></app-step3>
        </ng-container>

        <ng-container *ngIf="(currentStep$ | async)! === 4">
          <app-step4
            class="w-100"
            [createdAccount]="createdAccount"
            (finishClick)="nextStep()"
          ></app-step4>
        </ng-container>
      </div>
    </form>
  </div>
</div>
